import adminAuthService from "@/features/Admins/Auth/services";
import authService from "@/features/auth/services";
import axios, { AxiosInstance } from "axios";

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_SRI_KRUNG_API,
  timeout: 60000,
  withCredentials: true,
});

const setupAxiosInterceptors = (axiosInstance: AxiosInstance): void => {
  axiosInstance.interceptors.response.use(
    async (response) => {
      if (
        response &&
        response.status === 401 &&
        response.data.error.message !== "unauthorized"
      ) {
        adminAuthService.removeIsLoggedIn();
        authService.removeIsLoggedIn();
      }

      // Return the response object
      return response;
    },
    async (error: any): Promise<any> => {
      if (error.status === 401) {
        adminAuthService.removeIsLoggedIn();
        authService.removeIsLoggedIn();
        location.href = "/";
      }
      // Reject the error
      return Promise.reject(error);
    }
  );
};

setupAxiosInterceptors(api);
